export default function initBodyClass() {
  document.body.classList.remove('no-js');
}
